// The reference cutoff of the group order (canteen) rules. It lives in a plain module so the
// restaurant mapper, which every list loads through MapperCollection, does not pull the canteen form
// components (and their date picker) into the entry bundle (tasks#211).
export const defaultCutoff = '2023-08-30 10:00'
